import React, { useState } from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { InteractiveTourOverlay } from '../../components/website/InteractiveTourOverlay';
import { ScheduleDemoForm } from '../../components/website/ScheduleDemoForm';
import { ProductHero } from '../../components/website/ProductHero';
export function PricingPage() {
  const [showTour, setShowTour] = useState(false);
  const [showDemo, setShowDemo] = useState(false);
  const plans = [{
    name: 'Free',
    price: '$0',
    description: 'Best for trying AI GTM, exploring plays',
    features: ['Limited Copilot actions', 'Access to public GTM plays', '1 workspace', 'Community AI config (view only)'],
    cta: 'Start free',
    ctaLink: '/signup'
  }, {
    name: 'Growth',
    price: '$999',
    period: '/mo',
    description: 'Full GTM platform for growing teams',
    features: ['Full GTM Studio access', 'Copilot for team', 'Orchestration for core flows', 'Dynamic Plays & Playbooks library', 'Integrations for CRM/MAP', 'Forecast dashboard (calculator + attainment)', 'Up to 15 programs per workspace'],
    cta: 'Start trial',
    ctaLink: '/trial',
    highlighted: true
  }, {
    name: 'Scale',
    price: 'Contact us',
    description: 'For large or global GTM teams running Studio, Copilot, Orchestration, Predictive, and partner motions',
    features: ['Everything in Growth', 'Advanced orchestration', 'Predictive and data & signals modeling', 'Multi workspace and region support', 'Priority support', 'Custom AI agent packs'],
    cta: 'Talk to sales',
    ctaLink: '/website/contact'
  }];
  const featureComparison = [{
    category: 'GTM Studio',
    features: [{
      name: 'Visual workspace',
      free: true,
      growth: true,
      scale: true
    }, {
      name: 'Account segmentation',
      free: 'Basic',
      growth: 'Advanced',
      scale: 'Advanced'
    }, {
      name: 'Play templates',
      free: '10',
      growth: '50+',
      scale: '100+'
    }, {
      name: 'Custom play builder',
      free: false,
      growth: true,
      scale: true
    }, {
      name: 'Programs per workspace',
      free: '1',
      growth: '15',
      scale: 'Unlimited'
    }]
  }, {
    category: 'Copilot',
    features: [{
      name: 'Copilot actions',
      free: 'Limited',
      growth: 'Full access',
      scale: 'Full access'
    }, {
      name: 'Account summaries',
      free: false,
      growth: true,
      scale: true
    }, {
      name: 'Buying group detection',
      free: false,
      growth: true,
      scale: true
    }, {
      name: 'AI email generation',
      free: false,
      growth: true,
      scale: true
    }, {
      name: 'Custom agent packs',
      free: false,
      growth: false,
      scale: true
    }]
  }, {
    category: 'Orchestration',
    features: [{
      name: 'Core workflows',
      free: false,
      growth: true,
      scale: true
    }, {
      name: 'Advanced orchestration',
      free: false,
      growth: false,
      scale: true
    }, {
      name: 'Event-based triggers',
      free: false,
      growth: true,
      scale: true
    }, {
      name: 'Multi-system workflows',
      free: false,
      growth: false,
      scale: true
    }]
  }, {
    category: 'Dynamic Plays',
    features: [{
      name: 'Public plays library',
      free: true,
      growth: true,
      scale: true
    }, {
      name: 'Custom plays',
      free: false,
      growth: '50',
      scale: 'Unlimited'
    }, {
      name: 'Play variants',
      free: false,
      growth: true,
      scale: true
    }]
  }, {
    category: 'Dynamic Playbooks',
    features: [{
      name: 'Curated playbooks',
      free: 'View only',
      growth: 'Full access',
      scale: 'Full access'
    }, {
      name: 'Custom playbooks',
      free: false,
      growth: true,
      scale: true
    }]
  }, {
    category: 'Data & Signals',
    features: [{
      name: 'CRM sync',
      free: false,
      growth: true,
      scale: true
    }, {
      name: 'Data enrichment',
      free: false,
      growth: 'Standard',
      scale: 'Premium'
    }, {
      name: 'Custom data sources',
      free: false,
      growth: '3',
      scale: 'Unlimited'
    }, {
      name: 'Advanced modeling',
      free: false,
      growth: false,
      scale: true
    }]
  }, {
    category: 'Predictive',
    features: [{
      name: 'Basic forecasting',
      free: false,
      growth: true,
      scale: true
    }, {
      name: 'Win probability scoring',
      free: false,
      growth: false,
      scale: true
    }, {
      name: 'Channel optimization',
      free: false,
      growth: false,
      scale: true
    }, {
      name: 'Partner & field modeling',
      free: false,
      growth: false,
      scale: true
    }]
  }, {
    category: 'Forecast',
    features: [{
      name: 'Calculator view',
      free: false,
      growth: true,
      scale: true
    }, {
      name: 'Charts & dashboards',
      free: false,
      growth: true,
      scale: true
    }, {
      name: 'Attainment tracking',
      free: false,
      growth: true,
      scale: true
    }, {
      name: 'Advanced export',
      free: false,
      growth: true,
      scale: true
    }]
  }, {
    category: 'Integrations',
    features: [{
      name: 'CRM/MAP integrations',
      free: false,
      growth: true,
      scale: true
    }, {
      name: 'Custom integrations',
      free: false,
      growth: '5',
      scale: 'Unlimited'
    }, {
      name: 'API access',
      free: false,
      growth: false,
      scale: true
    }]
  }, {
    category: 'Support',
    features: [{
      name: 'Community support',
      free: true,
      growth: true,
      scale: true
    }, {
      name: 'Email support',
      free: false,
      growth: true,
      scale: true
    }, {
      name: 'Priority support',
      free: false,
      growth: false,
      scale: true
    }, {
      name: 'Dedicated CSM',
      free: false,
      growth: false,
      scale: true
    }]
  }];
  const renderValue = (value: any) => {
    if (typeof value === 'boolean') {
      return value ? <CheckIcon className="w-5 h-5 text-green-600 mx-auto" data-id="element-7966" /> : <XIcon className="w-5 h-5 text-gray-300 mx-auto" data-id="element-7967" />;
    }
    return <span className="text-sm text-gray-900" data-id="element-7968">{value}</span>;
  };
  return <div className="w-full min-h-screen bg-white" data-id="element-7969">
      <ProductHero eyebrow="Pricing" title="Pricing that matches your GTM maturity." subtitle="Start with Free, grow with Growth, scale with Scale." primaryCta={{
      text: 'Interactive tour',
      href: '#',
      onClick: () => setShowTour(true)
    }} secondaryCta={{
      text: 'Schedule demo',
      href: '#',
      onClick: () => setShowDemo(true)
    }} gradient="pricing" data-id="element-7970" />
      {/* Pricing Cards */}
      <div className="max-w-7xl mx-auto px-6 py-20" data-id="element-7971">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-7972">
          {plans.map(plan => <div key={plan.name} className={`bg-white rounded-2xl p-8 ${plan.highlighted ? 'ring-2 ring-red-600 shadow-xl' : 'border border-gray-200'}`} data-id="element-7973">
              {plan.highlighted && <div className="inline-block px-3 py-1 bg-red-600 text-white text-xs font-semibold rounded-full mb-4" data-id="element-7974">
                  Most Popular
                </div>}
              <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-7975">
                {plan.name}
              </h3>
              <div className="mb-4" data-id="element-7976">
                <span className="text-4xl font-bold text-gray-900" data-id="element-7977">
                  {plan.price}
                </span>
                {plan.period && <span className="text-gray-600" data-id="element-7978">{plan.period}</span>}
              </div>
              <p className="text-sm text-gray-600 mb-6 min-h-[3rem]" data-id="element-7979">
                {plan.description}
              </p>
              <ul className="space-y-3 mb-8" data-id="element-7980">
                {plan.features.map((feature, index) => <li key={index} className="flex items-start gap-3" data-id="element-7981">
                    <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-7982" />
                    <span className="text-sm text-gray-700" data-id="element-7983">{feature}</span>
                  </li>)}
              </ul>
              <a href={plan.ctaLink} className={`block w-full px-6 py-3 rounded-lg font-medium text-center ${plan.highlighted ? 'bg-red-600 text-white hover:bg-red-700' : 'bg-gray-100 text-gray-900 hover:bg-gray-200'}`} data-id="element-7984">
                {plan.cta}
              </a>
            </div>)}
        </div>
        {/* Feature Comparison */}
        <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden" data-id="element-7985">
          <div className="px-8 py-6 bg-gray-50 border-b border-gray-200" data-id="element-7986">
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-7987">
              Complete Feature Comparison
            </h2>
          </div>
          <div className="overflow-x-auto" data-id="element-7988">
            {featureComparison.map(category => <div key={category.category} className="border-b border-gray-200 last:border-0" data-id="element-7989">
                <div className="px-8 py-4 bg-gray-50" data-id="element-7990">
                  <h3 className="text-lg font-semibold text-gray-900" data-id="element-7991">
                    {category.category}
                  </h3>
                </div>
                <table className="w-full" data-id="element-7992">
                  <thead data-id="element-7993">
                    <tr className="border-b border-gray-200" data-id="element-7994">
                      <th className="text-left px-8 py-3 text-sm font-semibold text-gray-900 w-1/2" data-id="element-7995">
                        Feature
                      </th>
                      <th className="text-center px-4 py-3 text-sm font-semibold text-gray-900" data-id="element-7996">
                        Free
                      </th>
                      <th className="text-center px-4 py-3 text-sm font-semibold text-gray-900" data-id="element-7997">
                        Growth
                      </th>
                      <th className="text-center px-4 py-3 text-sm font-semibold text-gray-900" data-id="element-7998">
                        Scale
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-7999">
                    {category.features.map((feature, index) => <tr key={index} className="border-b border-gray-100 last:border-0" data-id="element-8000">
                        <td className="px-8 py-4 text-sm text-gray-700" data-id="element-8001">
                          {feature.name}
                        </td>
                        <td className="px-4 py-4 text-center" data-id="element-8002">
                          {renderValue(feature.free)}
                        </td>
                        <td className="px-4 py-4 text-center" data-id="element-8003">
                          {renderValue(feature.growth)}
                        </td>
                        <td className="px-4 py-4 text-center" data-id="element-8004">
                          {renderValue(feature.scale)}
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>)}
          </div>
        </div>
      </div>
      {/* Overlays */}
      <InteractiveTourOverlay isOpen={showTour} onClose={() => setShowTour(false)} data-id="element-8005" />
      <ScheduleDemoForm isOpen={showDemo} onClose={() => setShowDemo(false)} data-id="element-8006" />
    </div>;
}